<template>
  <div class="dispatcher-panel-job-list main no-scrollbar">
    <div class="cards" :class="{ 'height-auto': isTall }">
      <DriverPanelPassengerDetail
        v-if="showPassengerDetail"
        :transaction="transaction"
        @editReceiptAmount="enterReceiptAmount"
      />

      <div class="card" v-for="t in jobs" :key="t.id">
        <div class="card-content" :style="backgroundColor(t)">
          <div v-if="scheduledTime(t) && showScheduleTag(t)">
            <p class="has-text-link scheduled">
              {{ $t("driver.scheduled-pickup-time") }}
              {{ scheduledTime(t) }} ({{ humanTimeOrTimeAgo(t) }})
            </p>
          </div>

          <div class="cash-button-more">
            <div class="fare">
              <span v-if="t.data.fare">฿{{ t.data.fare.price }}</span>
              <span v-else class="has-text-success">FREE</span>
            </div>
            <div style="flex: 1; margin: 0 5px">
              <a
                v-if="t.is_updating"
                class="button is-dark is-fullwidth"
                @click="infoToast('Please wait...')"
                :disabled="true"
                >{{ $t("updating") }}&nbsp;<i class="fa fa-spinner fa-spin"
              /></a>
              <a
                v-else-if="t.state === 'scheduled'"
                class="button is-primary is-fullwidth"
                @click="editTransaction(t, 'driver_arrived')"
                :disabled="editing"
                >{{ $t("Confirm") }}</a
              >
              <a
                v-else-if="t.state === 'confirmed'"
                class="button is-link is-fullwidth"
                @click="editTransaction(t, 'driver_arrived')"
                :disabled="editing"
                >{{ $t("driver.arrived") }}</a
              >
              <a
                v-else-if="t.state === 'driver_arrived'"
                class="button is-success is-fullwidth"
                @click="editTransaction(t, 'enroute')"
                :disabled="editing"
                >{{ $t("driver.pickup") }}</a
              >
              <a
                v-else-if="t.state === 'enroute'"
                class="button is-warning is-fullwidth"
                @click="preDropoff(t)"
                :disabled="editing"
                >{{ $t("driver.dropoff") }}</a
              >
              <a
                v-else-if="t.state === 'cancelled_by_passenger'"
                class="button is-danger is-fullwidth"
                @click="editTransaction(t, 'acknowledged')"
                :disabled="editing"
                >{{ $t("okay") }}</a
              >
            </div>
            <div
              v-if="t.state !== 'cancelled_by_passenger'"
              style="width: 80px"
            >
              <a class="button" style="padding: 14px" @click="detailPanel(t)">
                <i class="fa fa-ellipsis-v fa-lg" />
              </a>
              <a
                class="button is-dark"
                @click="manageDriver(t)"
                style="margin-left: 4px; padding: 7px"
              >
                <i class="fa fa-shuttle-van fa-small" />
              </a>
            </div>
          </div>

          <div class="media" @click="detailPanel(t)">
            <div class="media-left" style="margin-right: 3px">
              <figure class="image">
                <img :src="customerPic(t)" />
              </figure>
              <span v-if="t.data.ref" class="order-no">#{{ t.data.ref }}</span>
            </div>

            <div class="media-content is-size-5 no-scrollbar">
              <div class="has-text-weight-medium">
                <span class="single-line">
                  <span v-if="t.state === 'cancelled_by_passenger'">
                    <i class="fa fa-map-marker-alt has-text-danger" />
                    <span>{{ $t("driver.cancelled") }}</span>
                  </span>
                  <span v-else-if="t.state !== 'enroute'">
                    <i class="fa fa-map-marker-alt has-text-success" />
                    <span>{{
                      t.data.pickup_stop.name || $t("ride.pin-location")
                    }}</span>
                  </span>
                  <span v-else-if="t.data.dropoff_stop">
                    <i class="fa fa-map-marker-alt has-text-link" />
                    <span>{{
                      t.data.dropoff_stop.name || $t("ride.pin-location")
                    }}</span>
                  </span>
                </span>
              </div>

              <p>
                <span class="single-line">
                  <i class="fa fa-user fa-sm has-text-grey" />
                  <span class="has-text-weight-semibold" v-if="t.data.pax"
                    >x{{ t.data.pax }}</span
                  >
                  <span class="is-size-6">
                    <span>{{ customerName(t) }}</span>
                  </span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ManageDriverPanel
      v-if="manageTransaction"
      :transaction="manageTransaction"
      @close="manageTransaction = null"
      @update="update"
    />
  </div>
</template>

<script>
import EventBus from "../eventBus";
// import geo from "@/geo";
import DriverPanelPassengerDetail from "@/components/DriverPanelPassengerDetail.vue";
import ManageDriverPanel from "@/components/ManageDriverPanel.vue";

export default {
  name: "DispatcherPanelJobList",
  components: {
    DriverPanelPassengerDetail,
    ManageDriverPanel,
  },
  props: {
    isTall: Boolean,
  },
  data() {
    return {
      manageTransaction: null, // set with transaction to manage driver
      editing: false,
      showPassengerDetail: false,
      transaction: null,
      c: 0,
    };
  },
  computed: {
    jobs() {
      return this.$store.getters.getDispatcherTransactionsStateConfirmed;
    },
  },
  mounted() {
    setInterval(() => (this.c += 1), 10 * 1000); // countdown timer, should destroy?
    EventBus.$on("CLOSE_PASSENGER_DETAIL", () => {
      this.showPassengerDetail = false;
    });
    EventBus.$on("TRIGGER_OPEN_PASSENGER_DETAIL", (t) => {
      this.detailPanel(t);
    });
    EventBus.$on("EDIT_TRANSACTION_FROM_PASSENGER_DETAIL", (payload) => {
      this.editTransaction(payload.transaction, payload.state);
    });
    this.$store.subscribe((mutation) => {
      if (mutation.type === "setOngoingDispatcherTransactions") {
        this.$store.getters.getWorkerTransactionsStateEnroute.forEach((t) => {
          this.checkForgottenDropoff(t); // if enroute and very old then driver forgot to hit dropoff
        });
      }
    });
  },
  methods: {
    // t is for transaction
    detailPanel(t) {
      if (t.state === "cancelled_by_passenger") return;
      EventBus.$emit("OPEN_PASSENGER_DETAIL", t);
      this.console("open transaction detail", t);
      this.transaction = t;
      this.showPassengerDetail = true;
    },
    update() {
      this.updateOrdersFleetDispatcher();
    },
    humanTimeOrTimeAgo(t) {
      if (this.humanTime(t) !== "Passed") return this.humanTime(t);
      return this.timeAgo(t.data.scheduled_time);
    },
    customerName(t) {
      return t.customer.name || t.customer.phone_number;
    },
    isLate(t) {
      console.log("c", this.c);
      if (t.state === "confirmed") {
        var confirmedAt = t.data.event_confirmed;
        var minsAgo = (new Date() - new Date(confirmedAt)) / (1000 * 60);
        return minsAgo > 15;
      }
      if (t.state === "enroute") {
        var enrouteAt = t.data.event_enroute;
        minsAgo = (new Date() - new Date(enrouteAt)) / (1000 * 60);
        return minsAgo > 20;
      }
      return false;
    },
    backgroundColor(t) {
      if (t.data.type === "delivery" && this.isLate(t)) {
        return "background-color: var(--danger)";
      }
      if (t.data.hasOwnProperty("acknowledged") && !t.data.acknowledged) {
        return "background-color:#FF3860";
      }
      if (t.handled_by === this.userID()) {
        return "background-color:cyan"; // you are the driver
      }
      return null;
    },
    showScheduleTag(t) {
      var states = ["confirmed", "driver_arrived", "scheduled"];
      return states.includes(t.state);
      //   return true; return false;
    },
    callDriver(t) {
      var mobile = t.driver.phone_number;
      window.location.href = `tel:${mobile}`;
    },
    manageDriver(t) {
      this.manageTransaction = t;
      // EventBus.$emit("MANAGE_DRIVER", t);
      // this.$nextTick(() => this.displayModal(".manage-driver-modal"));
    },
    enterReceiptAmount(t) {
      if (!t.data.delivery.require_receipt) return; // doesn't require receipt
      this.$swal({
        title: this.$t("driver.enter-receipt-amount"),
        input: "number",
        inputPlaceholder: "฿",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: this.$t("submit"),
        cancelButtonText: this.$t("later"),
        inputValidator: (val) => {
          if (!val || !val.length) return this.$t("driver.enter-price");
        },
      }).then((val) => {
        if (!val.value) return; // skipped
        // save receipt amount in transaction data
        var price = val.value;
        var loader = this.loadingDots();
        t.is_updating = true; // add flag
        this.$store
          .dispatch("patchTransaction", {
            transactionID: t.id,
            data: { data: { receipt_price: parseInt(price) } },
          })
          .then(() => this.update())
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
        this.successToast(this.$t("thank-you"));
      });
    },
    preDropoff(t) {
      if (t.data.delivery) this.detailPanel(t);
      else this.editTransaction(t, "alighted");
    },
    editTransaction(t, state) {
      if (state === "enroute") {
        if (t.data.delivery) this.enterReceiptAmount(t);
      }
      this.editing = true;
      this.console("driver editTransaction state", state, t);
      var loader = this.loadingDots();
      t.is_updating = true; // add flag
      this.$store
        .dispatch("patchTransaction", {
          transactionID: t.id,
          data: { state: state },
        })
        .then(() => this.update())
        .catch((err) => this.apiError(err))
        .finally(() => {
          loader.hide();
          this.editing = false;
          if (state === "alighted") {
            setTimeout(() => EventBus.$emit("SHOW_DRIVER_IGNORED_JOBS"), 1200);
          }
        });
    },
    checkForgottenDropoff(t) {
      if (t.state !== "enroute") return; // only check if state enroute, this is unnecessary
      var age = (new Date() - new Date(t.updated_at)) / 1000;
      if (age < 60 * 60) return; // if not updated in an hour driver probably forgot to end trip
      this.console("driver forgot to end trip", t);
      t.is_updating = true; // add flag
      this.$store
        .dispatch("patchTransaction", {
          transactionID: t.id,
          data: { state: "alighted" },
        })
        .then(() => this.update())
        .catch((err) => this.apiError(err));
    },
    businessPic(t) {
      var placeholder = this.$store.state.menuItemPlaceholderPic; // change to a shop cartoon?
      if (!t.business) return placeholder;
      return t.business.profile_pic_url || placeholder;
    },
    customerPic(t) {
      if (t.data.type === "delivery" && t.state === "confirmed") {
        return this.businessPic(t);
      }
      return t.customer.profile_pic_url || this.fallbackProfPic();
    },
    cash(t) {
      if (!t.data.fare) return false;
      return t.data.fare.cash;
    },
    tukpay(t) {
      if (!t.data.fare) return false;
      if (t.data.fare.tukpay !== 0) return true;
      if (this.suggestedPriceDiff(t) > 0) return true; // eat any difference at tukpay
      return false;
    },
    suggestedPriceDiff(t) {
      if (!t.data.fare) return false;
      if (!t.data.suggested_price) return false;
      return t.data.suggested_price - t.data.fare.price;
    },
  },
};
</script>

<style scoped>
.main {
  overflow: scroll;
  max-height: calc(100vh - 200px);
  /* padding-bottom: 10px; */
}
img {
  object-fit: cover;
  border-radius: 3px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  height: 80px;
  width: 80px;
}
.card .media {
  overflow: hidden;
}
.cards {
  height: 170px;
  /* height: 20vh; */
  /* width: 100vw; */
  overflow: scroll;
  /* overflow-x: hidden; */
}
.height-auto {
  height: auto;
}
div.card-content {
  padding: 6px;
  overflow: hidden !important;
}
.media-content .column {
  height: auto;
  overflow: hidden;
}
.tags {
  width: 450px; /*make this large so it fits all the text*/
  /* white-space: nowrap; */
  overflow: hidden;
  /* text-overflow: ellipsis; */
}
* {
  box-sizing: border-box;
}
.columns,
.columns:last-child {
  margin: 0;
  padding: 0;
}
.column .button {
  padding: 5px;
}
hr {
  margin-top: 3px;
  margin-bottom: 3px;
  height: 0;
}
.column {
  padding: 2px;
}
.tag {
  padding: 0 6px;
}
.cash-button-more {
  display: flex;
  /* width: 100vw; */
  margin-bottom: 6px;
}
/* .cash-button-more div {
  border: 1px red solid;
} */
.fa-map-marker-alt,
.fa-user {
  width: 30px;
  text-align: center;
}
.media-content {
  padding: 10px 0;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
}
.fare {
  width: 80px;
  font-weight: 500;
  font-size: 1.25em;
  background-color: #eee;
  line-height: 36px;
  border-radius: 4px;
}
.fare span {
  vertical-align: middle;
  height: 100%;
}
.scheduled {
  width: 100%;
  font-weight: 550;
  font-size: 0.9em;
  background-color: #ccc;
  padding: 6px 10px;
  margin-bottom: 2px;
}
.order-no {
  position: absolute;
  left: 4px;
  top: 112px;
  border-radius: 3px;
  border: 1.5px dotted grey;
  font-weight: 550;
  background-color: rgba(224, 255, 255, 0.9);
  font-family: "Bookman Old Style", "Times New Roman", Times, serif;
  box-shadow: 0 0 2px grey;
  /* font-size: 1.2em; */
  line-height: 1em;
  padding: 0 2px;
}
</style>